import { WidgetConfigObj } from './types'
import { StkSummary } from '../types'

interface ConfigParamObj {
  stkSummary: StkSummary
  hasTransferAccounts: boolean
  hasOpenSdaAccounts: boolean
  showBreakdown: boolean
  showWeeklyFinancialInsights: boolean
  showBadgeWidget: boolean
}

export const widgetsConfig = (paramObj: ConfigParamObj): WidgetConfigObj => {
  const {
    hasOpenSdaAccounts,
    hasTransferAccounts,
    stkSummary,
    showBreakdown,
    showWeeklyFinancialInsights,
    showBadgeWidget,
  } = paramObj

  return {
    accountsOverviewWidget: {
      copy: {
        displayName: 'Accounts Overview',
        description:
          'See your bank and investment accounts summarized in a pie chart.',
      },
      isEligible: (): boolean => showBreakdown,
    },
    stkWidget: {
      copy: {
        displayName: 'Buckets and Boosters',
        description: 'Organize and optimize your savings.',
      },
      isEligible: (): boolean =>
        (stkSummary.hasBuckets || stkSummary.hasBoosters) && hasOpenSdaAccounts,
    },
    transfersWidget: {
      copy: {
        displayName: 'One-Time Transfer',
        description: 'Make a One-Time Transfer.',
      },
      isEligible: (): boolean => hasTransferAccounts,
    },
    weeklyFinancialInsightsWidget: {
      copy: {
        displayName: 'Weekly Financial Insights',
        description:
          'Our financial experts cover everything from weekly market trends to big picture perspectives.',
      },
      isEligible: (): boolean => showWeeklyFinancialInsights,
    },
    badgeWidget: {
      copy: {
        displayName: 'Badges',
        description: 'Your Ally milestones and achievements',
      },
      isEligible: (): boolean => showBadgeWidget,
    },
  }
}
